import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router'

import { areaToUrl } from 'Utils/areaUtils'
import { BuildingV2 } from 'Containers/pages/'
import { BlurCont } from 'Layout'
import SvgIcon from 'Components/SvgIcon'
import { EVENT_TYPE, useInListingClickTracker } from 'Utils/inListingClickTracking'
import {
  _Address, _BuildingLink, _ListingTopBanner, _PlaceholderTitle, _Title, _RightBlock, _Buttons, _ShareButton,
  _AddressInlineLink, _AddressInlineSpan, _LeftBlock, _BackBtn, _BackBtnContainer,
  _CompareCta, _FavButton, _AddressContainer,
} from './style'

const TopBannerMobile = ({
  listing,
  lastPathStack,
  isMobileApp,
  hasAnyHiddenFields,
  requiredEmailVerification,
  isAddressPage = false,
  favHandler,
  onShareClick,
  favourited,
  googleAnalyticsEvent,
  closeModalListing,
  listingIsLocked,
  userIsAuthentificated,
}) => {
  const navigate = useNavigate()

  const handleBuildingLinkClick = () => {
    googleAnalyticsEvent({
      category: 'listing',
      action: '[Building Link Click]',
    })
  }
  const renderReversedBreadCrumb = () => {
    const breadCrumbs = listing.bread_crumb
    if(breadCrumbs && breadCrumbs.length) {
      const breadCrumbsLinkArr = []
      for(let i = breadCrumbs.length; i > 0; i -= 1) {
        const bc = breadCrumbs[i - 1]
        const Elem = bc.url ? _AddressInlineLink : _AddressInlineSpan

        if(!isMobileApp || (isMobileApp && i === 1)) {
          breadCrumbsLinkArr.push(
            <Fragment key={bc.id}>
              <Elem
                to={areaToUrl({ url: bc.url }, listing.offer)}
                breadcrumblevel={i}
                disableInApp
              >
                { bc.display_name }
              </Elem>
              {i > 1 ? <span>,&nbsp;</span> : ''}
            </Fragment>,
          )
        }
      }
      return breadCrumbsLinkArr
    }
  }
  const showBackBtn = isMobileApp && (closeModalListing || lastPathStack?.length > 1)

  const { submitEvent } = useInListingClickTracker({
    mlsNumber: listing?.mls_number,
    userIsAuthentificated,
    eventType: EVENT_TYPE?.share,
  })

  const onShareButtonClick = () => {
    if(listing?.featured) {
      submitEvent()
    }
    onShareClick('Mobile Listing Info')
  }

  const {
    title,
    building,
    address,
  } = listing || {}
  return (
    <_ListingTopBanner isMobileApp={isMobileApp}>
      <_LeftBlock showBackBtn={showBackBtn}>
        {
          !!showBackBtn && (
            <_BackBtnContainer data-test-id={'topBannerBackBtn'}>
              <_BackBtn
                onClick={
                  closeModalListing ||
                  (lastPathStack?.length > 1 ? () => navigate(-1) : null)
                }
              >
                <SvgIcon name="#icon-arrow-final" width={10} height={23} />
              </_BackBtn>
            </_BackBtnContainer>
          )
        }
        <_AddressContainer showBackBtn={showBackBtn}>
          {title && (
            <BlurCont blur={listingIsLocked}><_Title>{listing?.property_type === 'Unit' ? 'Unit ' : ''}{title}</_Title></BlurCont>
          )}
          {!title && (<_PlaceholderTitle />)}
          <_Address>
            <h2>
              {building && building.name && address ? (
                <Fragment>
                  <_BuildingLink
                    onMouseEnter={() => {
                      BuildingV2.preload()
                    }}
                    to={'/' + building.url}
                    componentData={{ component: 'Building', id: building.id }}
                    onClick={handleBuildingLinkClick}
                    // eslint-disable-next-line react/no-unstable-nested-components
                    mobileModalChildren={({ closeModalPage }) => (
                      <BuildingV2
                        buildingId={building.id}
                        modalBuildingData={building}
                        closeModalPage={closeModalPage}
                      />
                    )}
                    mobileModalKey={`buildingModal-${building.id}`}
                  >
                    {building.name}
                  </_BuildingLink>
                  <span>&nbsp;in&nbsp;</span>
                  {
                    renderReversedBreadCrumb()
                  }
                </Fragment>
              ) : listing ? (
                renderReversedBreadCrumb()
              ) : null}
            </h2>
          </_Address>
        </_AddressContainer>
      </_LeftBlock>
      <_RightBlock isAddressPage={isAddressPage}>
        {
          !hasAnyHiddenFields && (
            <_CompareCta
              listing={listing}
              hasNewFeatureTag
              listingPage
            />
          )
        }
        <_Buttons>
          {!isAddressPage && (
            <_FavButton
              name={'favorite-button'}
              aria-label="favourite"
              secondary
              small
              active={favourited}
              onClick={() => favHandler('Mobile Listing Info')}
            >
              <SvgIcon name="#icon-favourite" width={14} height={16} />
              <span>Favourite</span>
            </_FavButton>
          )}

          {!requiredEmailVerification && (
            <_ShareButton
              name={'share-button'}
              aria-label="share"
              secondary
              small
              onClick={onShareButtonClick}
            >
              <SvgIcon name="#icon-share-final" width={14} height={16} />
              <span>Share</span>
            </_ShareButton>
          )}
        </_Buttons>
      </_RightBlock>
    </_ListingTopBanner>
  )
}

TopBannerMobile.propTypes = {
  listing: PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.number,
    address: PropTypes.shape({}),
    offer: PropTypes.string,
    bread_crumb: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
      id: PropTypes.number,
      display_name: PropTypes.string,
    })),
    mls_number: PropTypes.string,
    featured: PropTypes.bool,
    property_type: PropTypes.string,
  }),
  lastPathStack: PropTypes.arrayOf(PropTypes.string),

  favourited: PropTypes.bool,
  isMobileApp: PropTypes.bool,
  requiredEmailVerification: PropTypes.bool,
  isAddressPage: PropTypes.bool,
  favHandler: PropTypes.func,
  onShareClick: PropTypes.func,
  hasAnyHiddenFields: PropTypes.bool,
  googleAnalyticsEvent: PropTypes.func,
  closeModalListing: PropTypes.func,
  listingIsLocked: PropTypes.bool,
  userIsAuthentificated: PropTypes.bool,
}

export default TopBannerMobile
